import React, { FC } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'

import PostalCode from '../components/PostalCode'
import { actionCreators } from '../actions'
import useNetwork from '@/checkout-instore-legacy/hooks/useNetwork'
import { setShippingWasFilled } from '@/checkout-instore-legacy/metadata/actions'

const PostalCodeContainer: FC = (props) => {
  const postalCodeProps = {
    ...props,
    isOnline: useNetwork(),
  }

  return <PostalCode {...postalCodeProps} />
}

const mapStateToProps = (state: RootState) => ({
  transaction: state.order.transaction,
  shipping: state.shipping,
})

const mapDispatchToProps = (dispatch: Dispatch<Action>) =>
  bindActionCreators({ ...actionCreators, setShippingWasFilled }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PostalCodeContainer)
